import React, { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_ORTU } from "@/lib/nav";
import { FileText } from "lucide-react";

export function JadwalOrtu() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/jadwal-belajar"); setItems(data); })(); }, []);
  return (
    <Layout nav={NAV_ORTU}>
      <PageTitle title="Jadwal Belajar Anak" />
      <section className="pp-card overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="pp-table-header"><th className="text-left px-5 py-3">Nama Siswa</th><th className="text-left px-5 py-3">Guru Pendamping</th><th className="text-left px-5 py-3">Lihat Jadwal</th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={3} className="text-center py-10 text-slate-400 italic">Belum ada jadwal.</td></tr>}
            {items.map(j => (
              <tr key={j.id} className="pp-row">
                <td className="px-5 py-3 font-medium">{j.nama_siswa}</td>
                <td className="px-5 py-3 text-slate-600">{j.nama_guru}</td>
                <td className="px-5 py-3"><a href={fileUrl(j.file_id)} target="_blank" rel="noreferrer" className="text-indigo-600 text-xs"><FileText className="w-3.5 h-3.5 inline" /> Lihat Jadwal Belajar</a></td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </Layout>
  );
}
